module.exports = __webpack_public_path__ + "static/GrayGminaMiastaOlesnica-4fd20a774ed9a84d55a777522df1da68.svg";